export default __webpack_public_path__ + "static/media/gsklogo.1b3bd8c5.png";